import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IAppUser } from '../../interfaces/user.interface';

@Injectable({
  providedIn: 'root'
})
export class PMEUserService {
  currentUserChangedSubj = new BehaviorSubject<void>(undefined);
  currentUserChanged$ = this.currentUserChangedSubj.asObservable();

  set currentUser(value: IAppUser | null) {
    this._currentUser = value;
    this.currentUserChangedSubj.next();
  }

  get currentUser(): IAppUser | null {
    return this._currentUser;
  }

  private _currentUser: IAppUser | null = null;
}
